import React from 'react';

const winners = [
  {
    month: 'April 2023 Contest',
    name: 'Rahul Sharma',
    location: 'Mumbai, Maharashtra',
    score: '19/20',
    time: '8:45',
  },
  {
    month: 'March 2023 Contest',
    name: 'Priya Patel',
    location: 'Ahmedabad, Gujarat',
    score: '20/20',
    time: '9:12',
  },
  {
    month: 'February 2023 Contest',
    name: 'Arjun Kumar',
    location: 'Bangalore, Karnataka',
    score: '18/20',
    time: '7:58',
  },
];

const PreviousWinners: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 py-12">
    <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">Previous Winners</h2>
    
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {winners.map((winner, idx) => (
        <div 
          className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
          key={idx}
        >
          <div className="bg-indigo-600 text-white px-6 py-3 text-center font-semibold">
            {winner.month}
          </div>
          
          <div className="p-6 text-center">
            <div className="flex justify-center mb-4">
              <svg 
                className="w-16 h-16" 
                fill="none" 
                viewBox="0 0 64 64"
                aria-hidden="true"
              >
                <circle cx="32" cy="32" r="32" fill="#e6e0ff"/>
                <circle cx="32" cy="28" r="12" fill="#7c3aed"/>
                <ellipse cx="32" cy="48" rx="16" ry="8" fill="#7c3aed"/>
              </svg>
            </div>
            
            <h3 className="text-xl font-bold text-gray-800 mb-1">{winner.name}</h3>
            <p className="text-gray-600 mb-4">{winner.location}</p>
            
            <hr className="border-gray-200 my-4" />
            
            <div className="flex justify-between text-sm">
              <div className="text-gray-700">
                Score: <span className="font-bold text-indigo-600">{winner.score}</span>
              </div>
              <div className="text-gray-700">
                Time: <span className="font-bold text-indigo-600">{winner.time}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PreviousWinners;